import React from "react";
import Group181 from "../Group181";
import "./Web1920142.css";

function Web1920142(props) {
  const { overlapGroup, group181Props } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-142 screen">
        <div className="overlap-group-52" style={{ backgroundImage: `url(${overlapGroup})` }}>
          <div className="group-181-1">
            <Group181 className={group181Props.className} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web1920142;
